// typescript
import { InjectionToken } from '@angular/core';
import { BrowserCacheLocation, Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration, MSAL_GUARD_CONFIG, MSAL_INSTANCE } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

const CLIENT_ID = environment.msal.clientId;
const AUTHORITY = environment.msal.authority;
const REDIRECT_URI = environment.msal.redirectUri;
const API_SCOPE = environment.apiScope;

export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access']
};

export const protectedResources = {
  functionApi: {
    endpoint: environment.apiBaseUrl,
    scopes: [API_SCOPE]
  }
};

// MSAL configuration: use localStorage to enable cross-tab authentication.
// This allows users to open links in new tabs without SSO re-authentication.
const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: REDIRECT_URI,
    navigateToLoginRequestUrl: false  // Prevents redirect loop after login
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false
  }
};

export function msalInstanceFactory(): PublicClientApplication {
  const instance = new PublicClientApplication(msalConfig);
  // Initialize the instance immediately (returns a promise but MSAL handles it internally)
  instance.initialize();
  return instance;
}

// Minimal guard & interceptor config using redirect flow
export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: 'redirect',
    authRequest: {
      scopes: loginRequest.scopes
    }
  } as unknown as MsalGuardConfiguration;
}